import { ShieldCheck } from "lucide-react";

export const BrandMark = ({ size = 28, className = "" }) => (
    <div
        className={`inline-flex items-center gap-2 ${className}`}
        dir="rtl"
        data-testid="brand-mark"
    >
        <div className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500/20 to-emerald-500/20 border border-cyan-500/30">
            <ShieldCheck className="h-5 w-5 text-cyan-300" />
        </div>
        <div className="leading-tight">
            <div className="text-base font-semibold tracking-tight">
                Guardian Pro
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
                Telegram Defense
            </div>
        </div>
    </div>
);

export default BrandMark;
